import React, { useEffect, useState, useContext } from 'react';
import { useQueryParams } from '../../shared/hooks/useQueryParams';

import Content from './components/Content';
import Footer from '../../shared/components/PublicPageFooter';
import Header from '../../shared/components/PublicPageHeader';
import { LoadingPage } from '../../shared/components/LoadingPage';
import useGetConfigs from './hooks/useGetConfigs';
import useConfigsStore from './store/configsStore';
import usePageStore from './store/pageStore';
import useSetFavicon from '../../shared/hooks/useSetFavicon';
import Services from './services';
import { GeneralContext } from '../../core/app-context/GeneralContext';

export function PublicOrderCreation() {
  const getQuery = () => {
    const queryParams = useQueryParams();
    const orderNumber = queryParams.get('orderNumber');
    const eticket = queryParams.get('eticket'); // This is here to add support for legacy links (privalia)
    const clientEmail = queryParams.get('clientEmail');
    const clientPhone = queryParams.get('clientPhone');
    const clientName = queryParams.get('clientName');
    const eboxFromQueryParam = queryParams.get('ebox')?.toUpperCase();
    return {
      orderNumber: orderNumber || eticket,
      clientEmail,
      clientPhone,
      clientName,
      eboxFromQueryParam,
    };
  };
  const { setErrorMessage } = useContext(GeneralContext);

  const [queryParametersData] = useState(getQuery());
  const [loadingQueryOrderCreation, setLoadingQueryOrderCreation] =
    useState(false);

  useGetConfigs();

  const storeId = useConfigsStore((state) => state.storeId);
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const storeConfigs = useConfigsStore((state) => state.storeConfigs);
  const loadingConfigs = useConfigsStore((state) => state.loadingConfigs);

  const setMemphisOrderInfo = usePageStore(
    (state) => state.setMemphisOrderInfo,
  );
  const setShowClientCreationForm = usePageStore(
    (state) => state.setShowClientCreationForm,
  );

  useSetFavicon(devolutionPageConfigs?.faviconUrl);

  useEffect(() => {
    if (queryParametersData && storeConfigs) {
      const processPageLoad = async () => {
        if (queryParametersData.orderNumber) {
          const link = await Services.getOrderLink({
            externalOrderCode: queryParametersData.orderNumber,
            storeId
          });
          // const link = false
          if (link) {
            window.location.href = link;
            return;
          }
        }
        if (storeConfigs?.enableMemphisOrderInfoSearch) {
          const memphisOrderInfo = await Services.getMemphisOrderInfo({
            storeId,
            memphisOrderId: queryParametersData.orderNumber,
          });
          if (!memphisOrderInfo.success) {
            setErrorMessage(
              memphisOrderInfo.message ||
                'Não foi possível ler o pedido Memphis, verifique as informações e tente novamente',
            );
            return;
          }
          setShowClientCreationForm(true);
          setMemphisOrderInfo(memphisOrderInfo.data);
          return;
        } else {
          const redirectToUrl = (url) => window.location.replace(url);
          setLoadingQueryOrderCreation(true);
          if (!queryParametersData.clientEmail) {
            setLoadingQueryOrderCreation(false);
            return;
          }
          let clientId = null;
          const getClientIdResult = await Services.getClientId(
            queryParametersData.clientEmail,
          );
          if (getClientIdResult) {
            clientId = getClientIdResult;
          } else {
            if (
              !queryParametersData.clientName ||
              !queryParametersData.clientPhone
            ) {
              setLoadingQueryOrderCreation(false);
              return;
            }
            const createClientIdResult = await Services.createClient({
              name: queryParametersData.clientName,
              email: queryParametersData.clientEmail,
              phone: queryParametersData.clientPhone,
            });
            if (!createClientIdResult) {
              setLoadingQueryOrderCreation(false);
              return;
            } else {
              clientId = createClientIdResult;
            }
          }
          //! we are ignoring orders with items or vtex search
          const order = {
            clientId,
            externalOrderCode: queryParametersData.orderNumber || '',
            commerce: 'N/A',
          };
          const saveOrderResult = await Services.createOrder(storeId, order);
          if (!saveOrderResult) {
            setLoadingQueryOrderCreation(false);
            return;
          }
          if (queryParametersData.eboxFromQueryParam) {
            const setReturnMethodResult = await Services.setOrderReturnMethod({
              orderId: saveOrderResult.orderId,
              returnMethodIndex: 1,
              boxCode: queryParametersData.eboxFromQueryParam,
            });
            if (!setReturnMethodResult.success) {
              setLoadingQueryOrderCreation(false);
              return;
            }
            if (!storeConfigs?.autoApproveDevolution) {
              redirectToUrl(saveOrderResult.selectReturnLocationUrl);
            } else {
              const approveOrderResult = await Services.approveOrRejectOrder({
                orderId: saveOrderResult.orderId,
                choice: true,
              });
              if (!approveOrderResult) {
                setLoadingQueryOrderCreation(false);
                return;
              }
              redirectToUrl(saveOrderResult.selectReturnLocationUrl);
            }
          } else {
            redirectToUrl(saveOrderResult.selectReturnLocationUrl);
          }
          setLoadingQueryOrderCreation(false);
        }
      };
      processPageLoad();
    }
  }, [storeConfigs, queryParametersData]);

  if (loadingConfigs || loadingQueryOrderCreation) {
    return <LoadingPage />;
  }
  return (
    <>
      <Header
        logoUrl={devolutionPageConfigs?.logoUrl}
        color={devolutionPageConfigs?.headerFooterColor || '#ffffff'}
      />
      <Content queryParametersData={{ ...queryParametersData }} />
      <Footer
        instaAccount={devolutionPageConfigs?.instagramAccount}
        fbAccount={devolutionPageConfigs?.facebookAccount}
        linkedinAccount={devolutionPageConfigs?.linkedinAccount}
        tiktokAccount={devolutionPageConfigs?.tiktokAccount}
        contactEmail={devolutionPageConfigs?.contactEmail}
        link1Title={devolutionPageConfigs?.link1Title}
        link1Url={devolutionPageConfigs?.link1Url}
        link2Title={devolutionPageConfigs?.link2Title}
        link2Url={devolutionPageConfigs?.link2Url}
        color={devolutionPageConfigs?.headerFooterColor || '#ffffff'}
        fontColor={devolutionPageConfigs?.footerIconsColor || '#ffffff'}
      />
    </>
  );
}
